<template>
  <category-page
    :category-list="categoryList"
    route-name="temps-home"
    title="Temps de travail"
    icon="mdi-timer"
  />
</template>

<script>
import CategoryPage from '../Common/CategoryPage'
export default {
  components: { CategoryPage },
  data () {
    return {
      categoryList: [
        {
          title: 'Saisie des temps',
          description: 'Saisie jour par jours du temps de travail par clients et tâches',
          icon: 'mdi-calendar-clock',
          to: { name: 'temps-saisie' },
          credentials: ['ROLE_TEMPS_SAISIE_EDIT']
        },
        {
          title: 'Synthèse',
          description: 'Synthèse des temps par clients et tâche sur un mois',
          icon: 'mdi-chart-pie',
          to: { name: 'temps-synthese' },
          credentials: ['ROLE_TEMPS_SYNTHESE_SHOW']
        }
      ]
    }
  }
}
</script>
